import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.19 Case 19</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_19"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 19. This is a positive case. The size and contrast have already been adjusted. Let's begin the review at the base of the brain, at the level of the cerebellum. As you can see, there is good gray-white contrast in the cerebellum. Moving into the temporal lobes, distinct white matter tracts are not clearly visible in the left temporal lobe. There is increased activity within the gray matter, resulting in loss of gray-white contrast. On the right, while a part of the white matter tract can be seen here and here, there is increased activity in the gray matter, causing loss of a gray-white contrast throughout the right temporal lobe.
              </p>
              <p>
                This pattern continues as we move superiorly in the frontal lobes bilaterally. Distinct, fingerlike projections are not easily identified, as there is increased activity in the gray matter. Posteriorly, in the occipital region, there’s also increased activity in the gray matter resulting in loss of gray-white contrast here.
              </p>
              <p>
                As we move superiorly and enter into the parietal region, white
                matter tracts are visible on the left as well as on the right
                but there is increased activity in the surrounding gray matter
                leading to loss of gray-white contrast. Increased activity is
                also seen in the precuneus, seen here. If we take a look at the
                sagittal images, you can more directly compare tracer activity
                in the cortical gray matter with that of the cerebellar gray
                matter, also confirming that there is loss of gray-white
                contrast throughout. Since there is loss of gray-white contrast
                in the occipital, temporal, frontal, and parietal regions, this
                scan is positive. If you called this case negative, please
                review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-18"
          nextLesson="/module-4/module-4-1-20"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1256573658&entry_id=1_z4uferfv&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_z4uferfv"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
